<template>
  <div class="botTableWrap ip">
    <div class="bot_label" v-if="!isExcel"><span><v-icon>find_in_page</v-icon>소재 / 일자별 리포트</span>
      <div>
        <select class="select_content" v-model="selected_nm">
          <option value="total">전체 보기</option>
          <template v-for="(creative, n) in campaignData">
            <option :value="creative.creative_nm" :key="n">{{setCreativeNm(creative)}}</option>
          </template>
        </select>
      </div>
    </div>
    <div class="inter_bot_wrap">
      <table class="inter_bot flipTable">
        <tr v-if="isExcel"><td>{{setCreativeNm(crNm)}}</td></tr>
        <tr>
          <template v-for="(header, i) in tableHeader">
            <th :key="header" :class="i === 0 ? 'ymd_td' : ''" v-if="checkMIP(header)">
              {{header}}
            </th>
          </template>
        </tr>
        <tbody>
          <template v-for="(daysData, index) in creativeData">
            <tr :class="[index === 0 ? 'f_inter_tr' : '_inter_tr', daysData.ad_knd_nm === null ? '_isEmpty' : '']" :key="index">
              <td v-for="(data, i) in dataKey"
                @click="showSubList(daysData, i)"
                class="dataTd_inter" :class="[i === 0 ? 'nm_Td' : '']"
                v-if="checkMIP(data)" :key="index + data">
                <v-icon class="icon" v-if="i === 0 && showIcon(daysData)">
                  {{checkDate(daysData.ymd) ? up : down}}
                </v-icon>
                <div class="inter" :class="[i !== 0 ? 'bot_dataWrap' : '', (selected_nm !== 'total' && i === 0) ? 'each_creative' : '']">
                  {{parseData(daysData[data], data)}}
                </div>
              </td>
            </tr>
            <template v-if="checkSubList(daysData)">
              <tr v-for="(creative, n) in daysData.list" :key="index + '_' + n" class="ip_subList">
                <td v-for="(data, i) in dataKey" class="dataTd_inter" :class="i === 0 ? 'sub_nm_Td' : ''" v-if="checkMIP(data)" :key="index + data">
                  <div class="inter" :class="i !== 0 ? 'bot_dataWrap' : ''">
                    {{ data === 'ymd' ? setCreativeNm(creative) : parseData(creative[data], data) }}
                  </div>
                </td>
              </tr>
            </template>
          </template>
          <tr>
            <th class="_total">합계</th>
            <th><div class="bot_dataWrap">{{ parseData(totalData.imp, '') }}</div></th>
            <th v-if="this.campaignType !== 'CPCV'"><div class="bot_dataWrap">{{ parseData(totalData.click, '') }}</div></th>
            <th v-if="this.campaignType !== 'CPCV'"><div class="bot_dataWrap">{{ parseData(totalData.ctr, 'ctr') }}</div></th>
            <th v-if="this.campaignType !== 'CPCV'"><div class="bot_dataWrap">{{ parseData(totalData.view, '') }}</div></th>
            <th v-if="this.campaignType !== 'CPCV'"><div class="bot_dataWrap">{{ parseData(totalData.vtr, '')}}</div></th>

            <th v-if="this.campaignType === 'CPCV'"><div class="bot_dataWrap">{{ parseData(totalData.click, '') }}</div></th>
            <th v-if="this.campaignType === 'CPCV'"><div class="bot_dataWrap">{{ parseData(totalData.ctr, 'ctr') }}</div></th>
            <th v-if="this.campaignType !== 'CPCV'"><div class="bot_dataWrap">{{ parseData(totalData.vtr, 'vtr') }}</div></th>
            <!-- <th v-if="this.campaignType === 'CPCV'"><div class="bot_dataWrap">100.0</div></th> -->
            <th v-if="isCampaignType(campaignType)"><div class="bot_dataWrap">{{ this.campaignType === 'CPCV' ? parseData(totalData.cpcv, '') : parseData(totalData.cpvc, '') }}</div></th>
          </tr>
        </tbody>
        <tr v-if="isExcel"><td></td></tr>
      </table>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapGetters } from 'vuex'
  import { parseData } from '@/assets/func'
  export default {
    name: 'InterCrBot',
    props: {
      campaginDaysData: Array,
      campaignData: Array,
      campaignType: String,
      checkDate: Function,
      clickDate: Function,
      crNm: Object,
      num: Number,
      isExcel: Boolean
    },
    data () {
      return {
        down: 'keyboard_arrow_down',
        up: 'keyboard_arrow_up',
        selected_nm: 'total',
        isIp: [
          'ymd',
          'imp_cnt',
          'click_cnt',
          'ctr',
          'view_cnt',
          'vtr',
          'play_cnt', // 모바일 인터플레이만
          'play_sec_avg',
          'end_rate',
          'play_Q1_rate',
          'play_Q2_rate',
          'play_Q3_rate'
        ],
        isCv: [
          'ymd',
          'imp_cnt',
          'view_cnt',
          'vtr',
          'click_cnt',
          'ctr',
          'cpvc',
          'play_sec_avg',
          'end_rate',
          'play_Q1_rate',
          'play_Q2_rate',
          'play_Q3_rate'
        ],
        isCpcv: [
          'ymd',
          'imp_cnt',
          'click_cnt',
          'ctr',

          'cpcv',
          'play_sec_avg',
          'end_rate',
          'play_Q1_rate',
          'play_Q2_rate',
          'play_Q3_rate'
        ],
        ipHeader: [
          '날짜',
          '노출수',
          '클릭수',
          'CTR(%)',
          'VIEW',
          'VTR(%)',
          '재생수',
          '평균재생(초)',
          '재생완료(%)',
          '재생Q1(%)',
          '재생Q2(%)',
          '재생Q3(%)'
        ],
        cvHeader: [
          '날짜',
          '노출수',
          'VIEW',
          'VTR(%)',
          '클릭수',
          'CTR(%)',
          'VIEW + CLICK',
          '평균재생(초)',
          '재생완료(%)',
          '재생Q1(%)',
          '재생Q2(%)',
          '재생Q3(%)'
        ],
        cpcvHeader: [
          '날짜',
          '노출수',
          '클릭수',
          'CTR(%)',
          '시청완료',
          '평균재생(초)',
          '재생완료(%)',
          '재생Q1(%)',
          '재생Q2(%)',
          '재생Q3(%)'
        ]
      }
    },
    methods: {
      checkMIP (key) {
        if (key !== 'play_cnt' && key !== '재생수') return true
        if (this.campaignType === 'HIP') return true
        else return false
      },
      parseData (data, key) {
        return parseData(data, key)
      },
      showIcon (data) {
        if (data.list === undefined || this.isExcel) return false
        if (data.list.length > 0 && data.list[0].creative_nm !== null) return true
        return false
      },
      checkSubList (data) {
        if (this.checkDate(data.ymd)) return true
        return false
      },
      showSubList (data, i) {
        if (i !== 0) return
        if (this.showIcon(data)) this.clickDate(data.ymd)
      },
      getSize (adKnd, creativeNm) {
        switch (adKnd) {
          case 'OHIP':
            return 'M640_360_FULL'
          case 'SOHIP':
            return 'M300_230_PLUS'
          case 'IP':
            if (creativeNm.split('/')[3].trim().replace(/(.png|.jpg|.jpeg|.gif|.mp4)$/, '') === '970_250') return '970_250_FULL'
            else return '640_360_FULL'
          case 'SIP':
            if (creativeNm.split('/')[3].trim().replace(/(.png|.jpg|.jpeg|.gif|.mp4)$/, '') === '970_250') return '970_250_PLUS'
            else return '640_360_PLUS'
          case 'FIP':
            return '640_360_PERF'
          case 'FOHIP':
            return 'M640_360_PERF'
          case 'DIP':
            return '640_360_SAVE'
          case 'DOHIP':
            return 'M640_360_SAVE'
          case 'C06OHIP':
            return 'M640_360_06'
          case 'C06IP':
            return '640_360_06'
          case 'C15IP':
            return '640_360_15'
          case 'C15OHIP':
            return 'M640_360_15'
          case 'EX2':
            return 'P300_250'
          case 'XIP':
            return '640_360'
          default :
            return ''
        }
      },
      getTotalData () {
        let data = this.creativeData
        let imp = _.sumBy(data, function (o) { return o.imp_cnt * 1 })
        let click = _.sumBy(data, function (o) { return o.click_cnt * 1 })
        let view = _.sumBy(data, function (o) { return o.view_cnt * 1 })
        let playCnt = _.sumBy(data, function (o) { return o.play_cnt * 1 })
        let ctr = click / imp * 100
        ctr = isNaN(ctr) ? 0 : ctr
        let vtr = view / (playCnt || imp) * 100
        vtr = isNaN(vtr) ? 0 : vtr
        const cpcv = this.campaignType === 'CPCV' ? _.sumBy(data, function (o) { return (o.cpcv === undefined ? 0 : o.cpcv) * 1 }) : 0
        const cpv = this.campaignType === 'CPV' ? _.sumBy(data, function (o) { return (o.cpvc === undefined ? 0 : o.cpvc) * 1 }) : 0
        let res = {imp: imp, click: click, ctr: ctr, view: view, vtr: vtr, cpcv: cpcv, cpv: cpv}
        if (!this.campaignType === 'CPCV' && this.campaignType.indexOf('CV') > -1) res.view_cnt = _.sumBy(data, function (o) { return (o.cpvc === undefined ? 0 : o.cpvc) * 1 })
        return res // 인터플레이 소재별 소재/일자별 리포트 부분
      },
      setCreativeKrNm (data) {
        return data.creative_kr_nm
      },
      getTargeting (nm) {
        const targeting = nm.split('/')[1]
        switch (targeting) {
          case 'CM':
            return '문맥매칭'
          case 'GT':
            return '지역매칭'
          case 'RT':
            return '리타겟팅'
          case 'AT':
            return '오디언스'
        }
      },
      whatKindOfCreative (adKnd) {
        switch (adKnd) {
          case 'OHIP':
            return '풀스크린(모바일)'
          case 'SOHIP':
            return '브랜드PLUS(모바일)'
          case 'IP':
            return '풀스크린'
          case 'SIP':
            return '브랜드PLUS'
          case 'FIP':
            return '퍼포먼스'
          case 'FOHIP':
            return '퍼포먼스(모바일)'
          case 'DIP':
            return '세이브'
          case 'DOHIP':
            return '세이브(모바일)'
          case 'C06IP':
            return '쇼츠06'
          case 'C06OHIP':
            return '쇼츠06(모바일)'
          case 'C15IP':
            return '쇼츠15'
          case 'C15OHIP':
            return '쇼츠15(모바일)'
          case 'EX2':
            return '팝업'
          case 'XIP':
            return 'PC BOX'
          default :
            return '배너'
        }
      },
      setCreativeKrNm_kr (adKnd) {
        switch (adKnd) {
          case 'OHIP':
          case 'EOHIP':
          case 'AOHIP':
          case 'GOHIP':
          case 'VOHIP':
          case 'VEOHIP':
          case 'VGOHIP':
          case 'VAOHIP':
          case 'CVOHIP':
          case 'CVAOHIP':
          case 'CVGOHIP':
            return 'OHIP'
          case 'SOHIP':
          case 'ESOHIP':
          case 'ASOHIP':
          case 'GSOHIP':
          case 'VSOHIP':
          case 'VGSOHIP':
          case 'VASOHIP':
          case 'CVSOHIP':
          case 'CVASOHIP':
          case 'CVGSOHIP':
            return 'SOHIP'
          case 'FOHIP':
          case 'EFOHIP':
          case 'AFOHIP':
          case 'GFOHIP':
          case 'VFOHIP':
          case 'VGFOHIP':
          case 'VEFHOIP':
          case 'VAFOHIP':
          case 'CVFOHIP':
          case 'CVAFOHIP':
          case 'CVGFOHIP':
            return 'FOHIP'
          case 'DOHIP':
          case 'VEDOHIP':
          case 'VDOHIP':
          case 'VGDOHIP':
          case 'VADOHIP':
            return 'DOHIP'
          case 'C06OHIP':
          case 'C06EOHIP':
          case 'C06AOHIP':
          case 'C06GOHIP':
            return 'C06OHIP'
          case 'C15OHIP':
          case 'C15EOHIP':
          case 'C15AOHIP':
          case 'C15GOHIP':
            return 'C15OHIP'
          case 'C06IP':
          case 'C06EIP':
          case 'C06AIP':
          case 'C06GIP':
            return 'C06IP'
          case 'C15IP':
          case 'C15EIP':
          case 'C15AIP':
          case 'C15GIP':
            return 'C15IP'
          case 'IP':
          case 'EIP':
          case 'AIP':
          case 'GIP':
          case 'VIP':
          case 'VEIP':
          case 'VAIP':
          case 'VGIP':
          case 'CVIP':
          case 'CVAIP':
          case 'CVGIP':
            return 'IP'
          case 'SIP':
          case 'ESIP':
          case 'ASIP':
          case 'GSIP':
          case 'VSIP':
          case 'VASIP':
          case 'VGSIP':
          case 'CVSIP':
          case 'CVASIP':
          case 'CVGSIP':
            return 'SIP'
          case 'FIP':
          case 'EFIP':
          case 'AFIP':
          case 'GFIP':
          case 'VFIP':
          case 'VAFIP':
          case 'VGFIP':
          case 'CVFIP':
          case 'CVAFIP':
          case 'CVGFIP':
            return 'FIP'
          case 'DIP':
          case 'VEDIP':
          case 'VDIP':
          case 'VADIP':
          case 'VGDIP':
            return 'DIP'
          case 'EX2':
          case 'EEX2':
          case 'AEX2':
          case 'GEX2':
          case 'CVEX2':
          case 'CVAEX2':
          case 'CVGEX2':
            return 'EX2'
          case 'XIP':
          case 'EXIP':
          case 'AXIP':
          case 'GXIP':
            return 'XIP'
          default :
            return 'BA'
        }
      },
      setCreativeNm (data) {
        if (data.creative_nm === undefined) return
        return this.whatKindOfCreative(this.setCreativeKrNm_kr(data.ad_knd)) + '_' + this.getTargeting(data.creative_nm) + '_' + (data.creative_kr_nm ? this.setCreativeKrNm(data) : data.creative_nm.split('/')[2]) + '_' + data.creative_nm.split('/')[3].trim().replace(/(.png|.jpg|.jpeg|.gif|.mp4)$/, '')
      },
      isCampaignType () {
        this.campaignType
        switch (this.campaignType) {
          case 'CPCV' :
            return true
          case 'CPV' :
            return false
          default :
            if (this.campaignType.indexOf('CV') > -1) return true // 'IP', 'AIP', 'OHIP', 'JIP', 'HIP'
            else return false
        }
      }
    },
    computed: {
      ...mapGetters([
        'getInterCreative'
      ]),
      creativeData () {
        if (this.isExcel) {
          return this.getInterCreative(this.crNm.creative_nm)
        }
        return this.getInterCreative(this.selected_nm)
      },
      tableHeader () {
        if (this.campaignType === 'CPCV') {
          return this.cpcvHeader
        } else if (this.campaignType === 'CPV') {
          return this.ipHeader
        } else if (this.campaignType.indexOf('CV') > -1) {
          return this.cvHeader
        } else {
          return this.ipHeader
        }
      },
      dataKey () {
        if (this.campaignType === 'CPCV') {
          return this.isCpcv
        } else if (this.campaignType === 'CPV') {
          return this.isIp
        } else if (this.campaignType.indexOf('CV') > -1) {
          return this.isCv
        } else {
          return this.isIp
        }
      },
      totalData () {
        return this.getTotalData()
      }
    },
    mounted () {
      if (this.isExcel) {
        let tables = this.$el.getElementsByTagName('table')
        for (let i = 0; i < tables.length; i++) {
          tables[i].setAttribute('id', 'inter_table_cr' + this.num)
        }
      }
    }
  }
</script>

<style scoped>
  .bot_label {
    position: absolute;
    top: -30px;
    left: 5px;
    height: 25px;
    font-weight: 500;
    color: #689f38;
    line-height: 25px;

    display: flex;
    justify-content: space-between;
    width: calc(100% - 5px);
  }
  .bot_label i {
    margin-right: 3px;
    font-weight: normal;
  }
  .icon {
    vertical-align: middle;
    color: #689f38;
    font-weight: bold;
  }

  .select_content {
    vertical-align: middle;
    border-radius: 6px;
    height: 23px;
    padding-bottom: 3px;
  }
  .select_content:hover {
    cursor: pointer;
  }

  .inter_bot_wrap {
    background: #fff;
    border: 1px solid #d1dce3;
    border-radius: 7px;
    padding: 5px 10px;
  }
  .inter_bot {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
  }
  .dataTd_inter.nm_Td {
    text-align: left;
    padding-left: 30px;
    min-width: 70px;
    max-width: 180px !important;
  }
  .sub_nm_Td {
    text-align: left;
    max-width: 250px !important;
  }
  .sub_nm_Td div {
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .dataTd_inter .icon {
    position: absolute;
    left: 10px;
  }
  ._isEmpty {
    background: #f7f9fa;
  }
  th, td {
    height: 25px;
  }
  th {
    border-bottom: 2px solid #eaeaea;
  }
  td {
    border-bottom: 1px solid #eaeaea;
  }
  tr:last-child th {
    border-bottom: none;
  }
  .ip_subList{
    background: #f2f3f5;
  }
  @media screen and (max-width: 800px) {
    .inter_bot_wrap {
      width: calc(100% - 22px);
    }
    .dataTd_inter.nm_Td, .dataTd_inter.sub_nm_Td {
      max-width: 120px !important;
    }
    .bot_dataWrap.inter {
      width: 85% !important;
    }
  }
  @media screen and (max-width: 600px) {
    .bot_dataWrap.inter {
      margin-left: 0 !important;
      margin-right: 10px !important;
      width: 100% !important;
    }
    .nm_Td, .sub_nm_Td {
      width: 60px;
      -ms-word-break: break-all;
      word-break: break-all;
      white-space: initial;
      height: 40px;
      line-height: 20px;
    }
    th, td {
      border-bottom: none;
      height: 30px;
    }
    ._total {
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
    .ymd_td {
      height: 40px;
      line-height: 40px;
    }
    .nm_Td {
      line-height: 40px;
    }
    .dataTd_inter.nm_Td {
      min-width: 50px !important;
    }
    .f_inter_tr .dataTd_inter {
      padding-right: 0 !important;
      padding-left: 5px;
    }
    ._inter_tr .dataTd_inter {
      padding-right: 0 !important;
      padding-left: 3px;
    }
    .dataTd_inter {
      padding-left: 5px;
      width: 90px;
    }
    .each_creative {
      margin-left: 25px;
    }
    .dataTd_inter .icon, .dataTd_inter.nm_Td div {
      display: inline !important;
    }
    .dataTd_inter .icon {
      position: relative;
    }
    .dataTd_inter.nm_Td div, .dataTd_inter.sub_nm_Td div {
      width: 100%;
      height: 40px;
      padding-left: 0;
      overflow: hidden;
      white-space: normal;
      text-align: left;
      word-wrap: break-word;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  @media screen and (max-width: 400px) {
    .bot_label i {
      display: none;
    }
    .select_content {
      width: 200px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// InterPlayCrBottom.vue?f4332088